import uuidv4 from 'uuid/v4'
import { sendPlatformActivity, resetAnalyticsAuth } from './client'
import { isMockApi } from '../../mock/isMockApi'
import { getSessionContext } from './session'

export const adoptionEnabled = () => process.env.REACT_APP_ADOPTION_ENABLED === 'true' && !isMockApi()

// One identifier per action; transport retries preserve it. No input text is collected.
export const trackActivity = (action, entry = false) => {
  const context = getSessionContext(true)
  if (!adoptionEnabled() || !context) return context
  void sendPlatformActivity({
    version: 1, event_id: uuidv4(),
    event_name: entry ? 'ia_entry_clicked' : 'platform_action', action,
    origin: entry ? 'header_button' : 'platform',
    analytics: context, occurred_at: new Date().toISOString(),
  })
  return context
}

export const handleAnalyticsMessage = event => {
  if (!event.data || event.data.type !== 'INFORMED_ANALYTICS_CONTEXT_REQUEST') return false
  const frame = document.querySelector('iframe[data-informed-ai]')
  let origin
  try { origin = new URL(process.env.REACT_APP_AI_ASSISTANT_URL).origin } catch (error) { return false }
  if (!frame || event.source !== frame.contentWindow || event.origin !== origin) return false
  const { requestId, action } = event.data
  if (typeof requestId !== 'string' || requestId.length > 80 || !['question', 'reference', 'activity'].includes(action)) return false
  const context = trackActivity(action === 'activity' ? 'click' : action)
  event.source.postMessage({ type: 'INFORMED_ANALYTICS_CONTEXT', requestId,
    context: adoptionEnabled() ? context : null }, origin)
  return true
}

export const installActivityTracking = () => {
  trackActivity('navigation')
  window.addEventListener('popstate', () => trackActivity('navigation'))
  let last = '', lastTime = 0
  const humanAction = event => {
    if (!event.isTrusted) return
    const context = getSessionContext(true)
    if (!context) return
    // Every action extends the session. At most one activity fact / 10s; day and session changes always emit.
    const key = context.session_id + new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' })
    if (key === last && Date.now() - lastTime < 10000) return
    last = key; lastTime = Date.now()
    trackActivity(event.type === 'keydown' ? 'keyboard' : event.type === 'scroll' ? 'scroll' : event.type)
  }
  ;['click', 'keydown', 'submit', 'scroll'].forEach(type => document.addEventListener(type, humanAction, { capture: true, passive: true }))
  window.addEventListener('informed:login', () => { resetAnalyticsAuth(); trackActivity('login') })
  window.addEventListener('informed:logout', () => { trackActivity('logout'); resetAnalyticsAuth() })
}
